var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 858,
    height: 583,
    viewBox: "0 0 858 583",
    fill: "none",
    id: "svg35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 805.765,581 H 642.5 429 22 C 10.9543,581 2,572.046 2,561 V 310.982 c 0,-11.046 8.9543,-20 20,-20 h 814 c 11.046,0 20,-8.954 20,-20 V 22 C 856,10.9543 847.046,2 836,2 H 44.397338",
    stroke: "#9ee9ce",
    strokeOpacity: 0.8,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs33"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3287_479",
    x1: 84.1486,
    y1: -2.44363,
    x2: 612.816,
    y2: 537.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015D53",
    id: "stop28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B56E",
    id: "stop30"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.af5badd3bfb00e04463ce500e31b0101.svg";
export { ForwardRef as ReactComponent };